import React, {useEffect, useMemo, useState} from 'react';
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {COMPUTER_ROOM_ACCESS_LIST_HEADER} from "../../../../components/table/header/Headers";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import Search from "../../../../components/search/Search";
import {removeComputerRooms} from "../../../../api/computerRoom/ComputerRoomService";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import SearchSection from "../../../../components/search/SearchSection";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";
import ComputerRoomApprovalSettings from "../ComputerRoomApprovalSettings";

function ComputerListType({checked, data, dataHook, pageInfo, date}) {
    const navigate = useNavigate();

    const listType = [
        {id: '결재', name: "결재"},
        {id: '대기', name: "대기"},
        {id: '전결', name: "전결"},
        {id: '반려', name: "반려"},
    ];

    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    const [header, setHeader] = useState({order: COMPUTER_ROOM_ACCESS_LIST_HEADER, exclude: []});

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, COMPUTER_ROOM_ACCESS_LIST_HEADER, setHeader, [], () => {}, () => {}, 'computer_room_list');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "출입 상세"),
            url: `/settings/computerRoom/${id}`,
        });
    };

    const deleteComputerRoom = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 출입명단을 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeComputerRooms({ids}).then((response) => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
            } else if (response.status === 201) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
        refresh();
    };

    const computerRoomJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <ComputerRoomApprovalSettings />

            <Search refresh={refresh} entity={'computer_room_list'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} searchBar={{placeHolder: '소속, 직위, 성명, 연락처, 방문위치, 방문목적, 결재상태'}} size date={searchDate} detail>
                <SearchSection>
                    <SearchComboBox title={"결재상태"} code={listType} target={"type"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "type")}
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={computerRoomJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {computer_room_list: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'computer_room_list')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="ComputerRoom" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteComputerRoom}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveToast({message: "삭제할 출입명단을 선택해주세요."});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export default ComputerListType;
